import { render, staticRenderFns } from "./inventoryDetail.vue?vue&type=template&id=733ebc6a&scoped=true&"
import script from "./inventoryDetail.vue?vue&type=script&lang=js&"
export * from "./inventoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./inventoryDetail.vue?vue&type=style&index=0&id=733ebc6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733ebc6a",
  null
  
)

export default component.exports